// FairFix Google reviews — verbatim.
//
// AUTHENTICITY RULE (strict)
//   Every entry below is copied byte-for-byte from Corey's Google Business
//   Profile. No spelling, punctuation, capitalisation, apostrophe or emoji
//   normalisation. Where the text contains a "\n" escape, the runtime stores
//   it as a real line break and the card renders it via CSS white-space:
//   pre-line. If you find a typo (e.g. "Fairfax", "greatful", "Exeptional",
//   "I doesnt hurt", missing apostrophes) leave it alone — that is what the
//   customer wrote and correcting it would misrepresent the reviewer.
//
// Shape:
//   { name: string, tag: string | null, text: string | null,
//     googleReviewId?, sourceUrl?, rating?, observedDate?, verifiedAt? }
//   • tag  = null → no tag chip renders on the card
//   • text = null → card shows stars + tag + name only (no quote block)
//
// Original 22 remain unchanged in Corey's supplied order (2026-08-31),
// David Parry first. Eight manually verified entries appended 2026-10-08:
// 30 public reviews = 26 written + 4 rating-only, all five stars.
// The original 22 have no per-entry rating field; their verified rating is 5.
// observedDate is Google's relative label AS OBSERVED on verifiedAt, not an
// exact publication date. Never derive a publication date from that label.
// No automatic sync. Exclude the owner's separate pinned Corey Vincent review.
// New tags remain null unless actually verified. Do not sort or rewrite text.
export const REVIEWS = [
  {
    name: 'David Parry',
    tag: 'Great price',
    text: "had Corey complete some carpentry work for me and the quality was outstanding. His attention to detail, professionalism, and workmanship were excellent from start to finish. Having also worked alongside him, I know how much pride he takes in his craft and how committed he is to delivering a high-quality result. I'd have no hesitation recommending him to anyone looking for a reliable carpenter in Tasmania.",
  },
  {
    name: 'Netty Garlo',
    tag: null,
    text: "Had a media wall with LED lights built for my mum and we both couldn't be happier with the result. The workmanship was excellent, everything was done professionally and to a really high standard. Would definitely recommend!",
  },
  {
    name: "Michelle O'keefe",
    tag: null,
    text: "Fast quote, quality work and extremely professional from start to finish. Couldn't be happier with the result. Thanks Corey and team",
  },
  {
    name: 'beach lisa',
    tag: null,
    text: 'Wow! Fast quote, job done quick which kept the labour costs down. Im a single lady and feel ive been ripped off before as I know nothing of the pricing etc in this field. Im going through this business everytime for future jobs. I doesnt hurt either to be dealing with people that are kind and thoughtful of the economy we are all living in. Wrapped with their integrity!',
  },
  {
    name: 'Jed Leggett',
    tag: 'Great price',
    text: 'Top quality work, very competitive prices and a great understanding of his trade that can only come from years of experience. Would highly recommend',
  },
  {
    name: 'I&J K',
    tag: 'Reasonable price',
    text: 'Corey went out of his way to help us out immediately on an urgent job - great workmanship, enthusiastic and reliable! Great to find someone we feel confident to engage again in the future.',
  },
  {
    name: 'Georgia Kaniaros',
    tag: null,
    text: 'Thank you Corey for the wonderful work you did, installing our canopy. We are so happy to finally have shelter from the wind and rain. We will definitely consider you in the near future.',
  },
  {
    name: 'Holly Richards',
    tag: 'Great price',
    text: 'Corey really listened to what I needed done and made sure he gave me exactly that. Fantastic work, thank you so so much',
  },
  {
    name: 'Bill Graham',
    tag: null,
    text: 'Quality work, on time, and very professional. Weatherboards they repaired made my house look unbelievable, very happy with it.',
  },
  {
    name: 'Kalioppy Miller',
    tag: null,
    text: 'Corey went above and beyond for my family.\nForever greatful.\nNothing was an issue for him.\nExeptional work, very efficient and very polite.\nAnyone who hires Corey are extremely lucky and fortunate.\n\nThank you so much',
  },
  {
    name: 'Halle Griggs',
    tag: null,
    text: 'This guy is gun! Highly recommend. Would not hire anyone else and can promise you he will do an amazing job! Attention to detail 👌🏻',
  },
  {
    name: 'Natalie Darko',
    tag: 'Great price',
    text: "Corey was quick with coming to give me a quote and even faster at getting the job done! Fantastic service from Fairfix, I'm so happy with the work I received and will be using them for all my future projects.",
  },
  {
    name: 'Sam Kaniaros',
    tag: null,
    text: 'Thank you Corey for your amazing work.\nAnyone who hires Corey has a knowledgeable\nPolite, efficient worker.\nNothing was a trouble for him.\nMy canopy looks great.\nBig cheers',
  },
  {
    name: 'Reece Fergusson',
    tag: 'Great price',
    text: "Outstanding job done by these guys! Couldn't recommend them enough ❤️",
  },
  {
    name: 'Colleen Muskett',
    tag: null,
    text: 'Corey does a fabulous job I highly recommend to all thank you young man',
  },
  {
    name: 'Jacob Pickering',
    tag: null,
    text: 'Highly recommend. Fairfax completed some carpentry repairs as part of our renovation on an older home and the quality of the work was excellent. They were very enthusiastic and nothing was a problem.',
  },
  {
    name: 'Jacob Easton',
    tag: null,
    text: 'Great service',
  },
  {
    name: 'Jett Vincent',
    tag: 'Reasonable price',
    text: 'Great service, fast, efficient',
  },
  {
    name: 'Mia',
    tag: null,
    text: 'Great business did a great job on my house',
  },
  {
    name: 'sorry im late',
    tag: null,
    text: 'Excellent Workmanship',
  },
  {
    name: 'codie hall',
    tag: 'Great price',
    text: null,
  },
  {
    name: 'Google Account',
    tag: 'Great price',
    text: "This guy renovated my entire house, kitchen, living & bathroom, cannot fault this skilled tradesmen's abilities, and the deck that he done also came up looking mint.",
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2xKdFMxVkVkV0ZHVFZabmQzTmFXWFl6UTBOU1MyYxAB',
    name: 'Emma Van steenis',
    observedDate: '2 months ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/105120929193262752845/reviews?hl=en-AU',
    text: 'Corey did an outstanding job, fixing all my internal windows. from haveing cracked steals and lots of damage I can finally keep my home warm. 10/10 he is amazing at what he dose, takes his time, dedicated and very respectful',
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2tobVVuRmhTbEk1ZEVWbFNFMVRXakpYU25WQlJrRRAB',
    name: 'Sahil Hussain Lali',
    observedDate: '16 hours ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/110275367553580416725/reviews?hl=en-AU',
    text: "I recently hired Fairfix to do some carpentry work around my home, including doorframe repairs, fixing my deck, and building a brand-new set of stairs—and I couldn't be happier with the results! Corey did an absolute stellar job. He was extremely efficient, professional, and paid great attention to the quality of his work. The new stairs and repairs look fantastic, and the whole process was seamless. I completely love how everything turned out. Highly recommend Corey and Fairfix to anyone needing reliable home repairs!",
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2pOaGVGQldaREV0VURWVlVsaDNNRVpoVFc0eFNWRRAB',
    name: 'Reuben Szlezak',
    observedDate: 'a day ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/100420019729100776319/reviews?hl=en-AU',
    text: 'Great service, great attitude and cares about his clients. Highly recommend',
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT21FNGRuVTRiREl0YzNwclZVVjJjR2hYZFVzdFZtYxAB',
    name: 'Chris Kaniaros',
    observedDate: 'a month ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/109434014959521629672/reviews?hl=en-AU',
    text: "Thank you Corey for the great insulation you did.\nPrice was great, very efficient. I'll definitely be using you again in the future.\nBig cheers",
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2xOd1NteHFSRWQwUkZCRFEwdERObFJZTjFGSk9WRRAB',
    name: 'Channel Not Found',
    observedDate: 'a month ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/103165191021780787986/reviews?hl=en-AU',
    text: '5 Stars Fairfix',
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2xWR1MzTXlVMk5TVjFwWVowSjVaekk0VUZWS1VFRRAB',
    name: 'Adam',
    observedDate: '14 hours ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/107065279082727669096/reviews?hl=en-AU',
    text: null,
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2xKWVNVNW9OVlppTUdZd1pGaERUVGhVTkhkTldWRRAB',
    name: 'Sumeet Oberai SMILE',
    observedDate: 'a month ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/108714654590876047261/reviews?hl=en-AU',
    text: null,
    tag: null,
    verifiedAt: '2026-10-08',
  },
  {
    googleReviewId: 'Ci9DQUlRQUNvZENodHljRjlvT2pSVWFrRmZYM1JoZGs4MWVITkxTV1ZxWmtaVk1GRRAB',
    name: 'Travis Frankcombe',
    observedDate: 'a month ago',
    rating: 5,
    sourceUrl: 'https://www.google.com/maps/contrib/116549467632777237277/reviews?hl=en-AU',
    text: null,
    tag: null,
    verifiedAt: '2026-10-08',
  },
];
